// extracted by mini-css-extract-plugin
module.exports = {"borderRadius":"Figure_borderRadius__JrYdN","figCaption":"Figure_figCaption__an6Ic"};